import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Alert, Button, Checkbox, Col, ControlLabel, Form, FormControl, FormGroup, Glyphicon, Row} from 'react-bootstrap'


class Login extends Component {

	constructor(props) {
		super(props);

		this.state = {
			tab: "login",
			forgottenPassword: false,
			login: {
				email: "",
				password: "",
				rememberMe: 1,
				errorSeen: false
			}
		};

		this.handleLoginInputChange = this.handleLoginInputChange.bind(this);
		this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
		this.handleForgottenPasswordSubmit = this.handleForgottenPasswordSubmit.bind(this);

		this.renderAlert = this.renderAlert.bind(this);
	}

	handleLoginInputChange(e) {
		const target = e.target || e;
		let value = target.value;
		const name = target.id;

		const {login} = this.state;
		if (target.type === 'checkbox' && !target.checked) {
			login[name] = 0
		} else {
			login[name] = target.type === 'checkbox' ? 1 : value
		}
		this.setState({login: login})
	}

	handleForgottenPasswordSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {login} = this.state;
		login.errorSeen = false;
		this.setState({login: login});
		this.props.onForgottenPassword(login.email).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				this.handleLoginModalDismissClick()
			}
		})
	}

	handleLoginSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {login} = this.state;
		login.errorSeen = false;
		this.setState({login: login});
		this.props.onLogin(login.email, login.password, login.rememberMe)
	}

	renderAlert(error) {
		return <Alert bsStyle="danger">
			<h4>Chyba</h4>
			<p>{error}</p>
		</Alert>
	}

	renderLogin() {
		const {login, forgottenPassword} = this.state;
		const {session} = this.props;

		return (
			<div id={"login-tab"}>
				<h2>{forgottenPassword ? 'Obnova hesla' : 'Přihlášení'}</h2>
				<Form horizontal onSubmit={forgottenPassword ? this.handleForgottenPasswordSubmit : this.handleLoginSubmit}>

					<div>
						{session.error && !login.errorSeen && this.renderAlert(session.error)}
						{forgottenPassword && <p>Na emailovou adresu vašeho účtu vám budou zaslány instrukce pro obnovu hesla.</p>}
						<FormGroup controlId="email">
							<Col componentClass={ControlLabel} sm={3}>
								Email
							</Col>
							<Col sm={7}>
								<FormControl type="email" name="email" value={login.email} onChange={this.handleLoginInputChange}/>
							</Col>
						</FormGroup>

						{!forgottenPassword && <FormGroup controlId="password">
							<Col componentClass={ControlLabel} sm={3}>
								Heslo
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password" value={login.password} onChange={this.handleLoginInputChange}/>
							</Col>
						</FormGroup>}

						{!forgottenPassword && <FormGroup>
							<Col smOffset={3} sm={7}>
								<Checkbox id="rememberMe" name="rememberMe" checked={login.rememberMe} onChange={this.handleLoginInputChange}>Zapamatuj si mě</Checkbox>
							</Col>
						</FormGroup>}
					</div>

					<div className={"padded-buttons"}>
						{!forgottenPassword && <Row>
							<Col xs={6} className="text-left">
								<Button bsStyle="link" onClick={() => {
									const {login} = this.state;
									login.errorSeen = true;
									this.setState({forgottenPassword: true, login})
								}}>Zapomenuté heslo</Button>
							</Col>
							<Col xs={6} className="text-right">
								<Button type="submit" onClick={this.handleLoginSubmit} bsStyle="success"><Glyphicon glyph="lock"/> Přihlásit <Glyphicon glyph="chevron-right"/></Button>
							</Col>
						</Row>}
						{forgottenPassword && <Row>
							<Col xs={5} className="text-left">
								<Button onClick={() => {
									const {login} = this.state;
									login.errorSeen = true;
									this.setState({forgottenPassword: false, login})
								}}>Storno</Button>
							</Col>
							<Col xs={7} className="text-right">
								<Button type="submit" onClick={this.handleForgottenPasswordSubmit} bsStyle="success"><Glyphicon glyph="envelope"/> Zaslat instrukce</Button>
							</Col>
						</Row>}
					</div>
				</Form>
			</div>
		)
	}

	render() {
		const {tab} = this.state;

		return (
			<div id="login-page">
				<Row>
					<Col xs={8} xsOffset={2} md={6} mdOffset={3} lg={6} lgOffset={3}>
						{tab === 'login' && !this.props.params.token ? this.renderLogin() : null}
					</Col>
				</Row>
			</div>
		)
	}
}

Login.propTypes = {
	onLogin: PropTypes.func.isRequired,
	onForgottenPassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default Login


// WEBPACK FOOTER //
// ./src/components/Login.js